import { render, staticRenderFns } from "./ApplyRecord.vue?vue&type=template&id=00581fbd&scoped=true&"
import script from "./ApplyRecord.vue?vue&type=script&lang=js&"
export * from "./ApplyRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00581fbd",
  null
  
)

export default component.exports